import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { BookingWidgetComponent } from '@tv3/containers/widgets/booking-widget/booking-widget.component'
import { InquiryWidgetComponent } from '@tv3/containers/widgets/inquiry-widget/inquiry-widget.component'
import { CalendarWidgetComponent } from '@tv3/containers/widgets/calendar-widget/calendar-widget.component'
import { SearchWidgetComponent } from '@tv3/containers/widgets/search-widget/search-widget.component'
import { WidgetsComponent } from '@tv3/containers/widgets/widgets.component'
import { WebsiteGuard } from '@tv3/guards/website.guard'
import { InterstitialWidgetComponent } from '@tv3/containers/widgets/interstitial-widget/interstitial-widget.component'

export const routes: Routes = [
  {
    path: '',
    component: WidgetsComponent,
  },
  {
    path: 'booking',
    component: BookingWidgetComponent,
  },
  {
    path: 'calendar',
    component: CalendarWidgetComponent,
  },
  {
    path: 'search',
    component: SearchWidgetComponent,
    canActivate: [WebsiteGuard],
  },
  {
    path: 'inquiry',
    component: InquiryWidgetComponent,
  },
  {
    path: 'interstitial',
    component: InterstitialWidgetComponent,
    canActivate: [],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class WidgetsRoutingModule {}
